import { all, fork } from 'redux-saga/effects'

import customerAuth from './customerAuth.saga'
import customerOrder from './customerOrder.saga'
import wholesale from './wholesale.saga'
import shop from './shop.saga'
import payment from './payment.saga'
import inquiry from './inquiry.saga'

export default function* rootSaga() {
	yield all([fork(customerAuth)])
	yield all([fork(customerOrder)])
	yield all([fork(wholesale)])
	yield all([fork(shop)])
	yield all([fork(payment)])
	yield all([fork(inquiry)])
}
